<template>
  <footer class="footer" id="footer">
    <div class="container-fluid">
      <nav class="float-left">
        <ul>
          <li>
            <router-link :to="{ path:'/dashboard' }">
              <i class="fa fa-home"></i> dashboard
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright float-right">
        <strong>Copyright &copy; {{ new Date().getFullYear() }}
      <a href="">Budget Vals</a>.
      </strong> All rights reserved.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'Footer'
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/Footer.vue